import {
  getWorkGroupList,
  getWorkGroupXlsxTemplate,
  importWorkGroups,
} from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

const FETCH_ID = "WorkGroups";

export const useGetWorkGroupsTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, getWorkGroupXlsxTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetWorkGroups = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getWorkGroupList, {
    fallback: [],
  });

export const useSubmitWorkGroups = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importWorkGroups, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
